import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from '../locales/en/translation.json'; // English translations
import translationFR from '../locales/fr/translation.json'; // French translations

// Check localStorage first, then detect from browser
const savedLanguage = localStorage.getItem('appLanguage');
const detectedLanguage = savedLanguage || navigator.language.split('-')[0];

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      fr: {
        translation: translationFR,
      },
    },
    lng: detectedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;